<div mat-dialog-content>
    <p>{{ input }}</p>
</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="cancel()">{{ "BTN.OK" | translate }}</button>
</div>